import modeUrls from './modeUrls';
import modeRoleRestrictions from './modeRoleRestrictions';

const getModeInfo = modeConstant => ({
  url: modeUrls[modeConstant],
  roleRestrictions: modeRoleRestrictions[modeConstant]
});

export default getModeInfo;
